import React, { Component } from 'react';
import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

const ItemTypes = {
  DND_LIST: 'dndList',
  DND_ITEM: 'dndItem',
};

const dndItemSource = {
  beginDrag(props) {
    return { data: props.data };
  },
  isDragging(props, monitor) {
    return props.data === monitor.getItem().data;
  },
};

const dndItemTarget = {
  hover(targetProps, monitor) {
    const targetData = targetProps.data;
    const sourceProps = monitor.getItem();
    const sourceData = sourceProps.data;

    if (sourceData.name !== targetData.name) {
      targetProps.onMove({
        sourceData,
        targetData,
      });
    }
  },
};

const dndListTarget = {
  hover(targetProps, monitor) {
    const targetData = targetProps.items;
    const sourceProps = monitor.getItem();
    const sourceData = sourceProps.data;

    // console.log('sourceData', sourceData);
    // console.log('targetProps', targetProps);
    // console.log('targetData', targetData.length);

    if (targetData.length === 0) {
      targetProps.onMove({
        sourceData,
        targetProps,
      });
    }

    // if (sourceData.name !== targetData.name) {
      // targetProps.onMove({
        // sourceData,
        // targetData,
      // });
    // }
  },
};


@DragSource(ItemTypes.DND_ITEM, dndItemSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))
@DropTarget(ItemTypes.DND_ITEM, dndItemTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
}))
class DragAndDropItem extends Component {
  render() {
    const {
      connectDragSource,
      connectDropTarget,
      isDragging,
      data,
    } = this.props;
    // console.log('onMove', onMove);
    return connectDragSource(connectDropTarget(
      <li
        className="dndItem"
        style={{
          opacity: isDragging ? 0 : 1,
        }}
      >
        {data.name}
      </li>
    ));
  }
}

// @DragSource(ItemTypes.DND_ITEM, dndItemSource, (connect, monitor) => ({
  // connectDragSource: connect.dragSource(),
  // isDragging: monitor.isDragging(),
// }))
@DropTarget(ItemTypes.DND_ITEM, dndListTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
class DragAndDropList extends Component {
  render() {
    const { connectDragSource, connectDropTarget, name, items, onMove } = this.props;
    return connectDropTarget(
      <div className="dndList">
        <div className="dndList-header">{name}</div>
        <ul className="dndItems">
          {items && items.map(item => (
            <DragAndDropItem
              key={item.id}
              data={item}
              onMove={onMove}
            />
          ))}
        </ul>
      </div>
    );
  }
}

@DragDropContext(HTML5Backend)
@observer
class DragAndDrop extends Component {
  @observable lists;

  constructor(props) {
    super(props);

    this.init();
  }

  @action init() {
    // const { lists } = this.props;
    let lists = this.props.lists;
    const list1Ids = lists[1].items.map(item => item.id);
    // console.log('list1Ids', list1Ids);
    lists[0].items = lists[0].items.filter(item => {
      // console.log('item.id', item.id);
      return list1Ids.indexOf(item.id) === -1;
    });
    // console.log(lists[0].items);
    this.lists = lists;
    // this.lists = [
      // list0,
      // lists[1],
    // ];
  }

  // @action move = ({ sourceData, targetData }) => {
    // console.log(sourceData, targetData);
  // }
  @action move = ({ sourceData, targetData, targetProps }) => {
    const { onChange } = this.props;
    // console.log('sourceData', sourceData);
    // console.log('targetData', targetData);
    const dndLists = this.lists;

    const sourceDndList = dndLists.filter((dndList) => {
      return dndList.items.indexOf(sourceData) >= 0;
    })[0];
    const sourceDndItemIndex = sourceDndList.items.indexOf(sourceData);
    // get rid of the source
    sourceDndList.items.splice(sourceDndItemIndex, 1);

    let targetDndList;

    if (targetProps) {
      // console.log('move to different list', targetProps);
      targetDndList = targetProps;
    } else {
      targetDndList = dndLists.filter((dndList) => {
        return dndList.items.indexOf(targetData) >= 0;
      })[0];
    }

      const targetDndItemIndex = targetDndList.items.indexOf(targetData);

      // and move it to target
      if (targetDndList.items.length) {
        targetDndList.items.splice(targetDndItemIndex, 0, sourceData);
      } else {
        targetDndList.items.push(sourceData);
      }
    // this.lists = [
      // sourceDndList,
      // targetDndList,
    // ];
    this.lists = this.lists.map(list => {
      if (list.id === targetDndList.id) {
        return targetDndList;
      }
      if (list.id === sourceDndList.id) {
        return sourceDndList;
      }
      return list;
    });

    if (onChange) {
      onChange(this.lists);
    }
  };


  render() {
    // const { lists } = this.lists;
    return (
      <div className="dndLists">
        {this.lists && this.lists.map(list => (
          <DragAndDropList
            key={list.name}
            name={list.name}
            items={list.items}
            onMove={this.move}
          />
        ))}
      </div>
    );
  }
}

export default DragAndDrop;



// WEBPACK FOOTER //
// ./src/components/DragAndDrop/index.js